<template>
  <div class="noselect">
    <!-- :cpntLargura='pagina === 0 ? "830px" : "1150px"' -->
    <RF-Dialog
    :cpntStatus='statusGeral'
    :cpntLargura='"795px"'
    :cpntOnFecharDialog='cerNovPedidoFechar'>
      <template slot="titulo">
        <div>
          <!-- <button style="margin: 0px 5px" @click="cerNovPedidoAlterarPagina(0)">PAGINA 1</button>
          <button style="margin: 0px 5px" @click="cerNovPedidoAlterarPagina(1)">PAGINA 2</button>
          <button style="margin: 0px 5px" @click="cerNovPedidoAlterarPagina(2)">PAGINA 3</button>
          <br/> -->

          <i aria-hidden="true" class="fa fa-angle-double-right"></i>
          <span v-if="Object.keys(pedido).length >= 1"> Certificado Digital - Seu pedido!</span>
          <span v-else> Certificado Digital - Adquira já o seu!</span>
        </div>
      </template>

      <template slot="conteudo">
        <div class="cer-novo-pedido">
          <div v-if="pagina === 0">
            <table class="modelo">
              <tr>
                <td class="noselect direita img-certificado">
                  <img src='./safeweb.png' style="width: 200px"/>
                </td>
                
                <td class="valores">
                  <h3 v-html="tipos[0].nome"></h3>
                  <h5>VALIDADE: <span v-html="tipos[0].validade"></span></h5>
                  <h4><b>R$ <span v-html="cerNovPedidoFormatarValor(tipos[0].valor)"></span></b></h4>
                </td>
              </tr>
            </table>

            <table class="condicoes">
              <tr>
                <td :class="(checkbox.indexOf('pagamento') !== -1 ? 'checkbox-marcado' : 'checkbox-desmarcado')">
                  <div class="quadrado">
                    <div class="titulo">
                      <RF-Checkbox-Tabela :data-time='time' style='cursor: pointer; position: relative; top: 0px;'
                        :cpntStatus='""'
                        :cpntId='"cer-novo-pedido--checkbox--pagamento"' 
                        :cpntNome='"EMISSÃO DO CERTIFICADO"'
                        :cpntValue='"pagamento"'
                        :cpntChecked='checkbox'

                        :cpntOnChange='cerNovoPedidoOnChangeCheckbox'
                      ></RF-Checkbox-Tabela>
                    </div>
                    <div class="conteudo">
                      • Após realizar este pedido, nossa equipe entrará em contato com você (no período da tarde) para fazer o agendamento.<br/><br/>
                      • Nossa agenda fica aberta para validação presencial nas Segundas, Quartas e Sextas no período da tarde.
                    </div>
                  </div>
                </td>

                <td :class="(checkbox.indexOf('emissao') !== -1 ? 'checkbox-marcado' : 'checkbox-desmarcado')">
                  <div class="quadrado">
                    <div class="titulo">
                      <RF-Checkbox-Tabela :data-time='time' style='cursor: pointer; position: relative; top: 0px;'
                        :cpntStatus='""'
                        :cpntId='"cer-novo-pedido--checkbox--emissao"' 
                        :cpntNome='"VALIDAÇÃO PRESENCIAL"'
                        :cpntValue='"emissao"'
                        :cpntChecked='checkbox'

                        :cpntOnChange='cerNovoPedidoOnChangeCheckbox'
                      ></RF-Checkbox-Tabela>
                    </div>
                    <div class="conteudo">
                      • Após o agendamento, você será informado de todos os documentos necessários.<br/><br/>
                      • É necessário ser o Representante Legal da Empresa para gerar este certificado.<br/><br/>
                      • Nossa filial fica localizada na Rua Professor João Doetzer, 415 SLJ 02 no bairro Jardim das Américas em Curitiba/PR. (Com Estacionamento)
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td :class="(checkbox.indexOf('validacao') !== -1 ? 'checkbox-marcado' : 'checkbox-desmarcado')">
                  <div class="quadrado">
                    <div class="titulo">
                      <RF-Checkbox-Tabela :data-time='time' style='cursor: pointer; position: relative; top: 0px;'
                        :cpntStatus='""'
                        :cpntId='"cer-novo-pedido--checkbox--validacao"' 
                        :cpntNome='"FORMA DE PAGAMENTO"'
                        :cpntValue='"validacao"'
                        :cpntChecked='checkbox'

                        :cpntOnChange='cerNovoPedidoOnChangeCheckbox'
                      ></RF-Checkbox-Tabela>
                    </div>
                    <div class="conteudo">
                      • Boleto Bancário<br/><br/>
                      • O vencimento será daqui a cinco dias.<br/><br/>
                      • O boleto deve ser pago até 2 (dois) dias antes da validação presencial.
                    </div>
                  </div>
                </td>

                <td :class="(checkbox.indexOf('atualizacao') !== -1 ? 'checkbox-marcado' : 'checkbox-desmarcado')">
                  <div class="quadrado">
                    <div class="titulo">
                      <RF-Checkbox-Tabela :data-time='time' style='cursor: pointer; position: relative; top: 0px;'
                        :cpntStatus='""'
                        :cpntId='"cer-novo-pedido--checkbox--atualizacao"' 
                        :cpntNome='"COMO INSERIR NO ROTINA FÁCIL"'
                        :cpntValue='"atualizacao"'
                        :cpntChecked='checkbox'

                        :cpntOnChange='cerNovoPedidoOnChangeCheckbox'
                      ></RF-Checkbox-Tabela>
                    </div>
                    <div class="conteudo">
                      • Após a emissão do certificado conosco, será necessário gerar e inserir posteriormente o certificado no sistema.<br/><br/>
                      • Caso tenha dúvidas por favor entre em contato.
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="2" class="confirmar centro">
                  <RF-Button
                    :data-time='time'

                    :cpntStatus='""' 
                    :cpntId='"cer-novo-pedido-confirmar"' 
                    :cpntTexto='"Concordo"' 
                    :cpntClass='[ "btn", "btn-primary" ]'
                    :cpntMostrar='true'
                    :cpntDisabled='checkbox.length !== 4'
                    :cpntExplica='(checkbox.length !== 4 ? { titulo: "", mensagem: "Para continuar é necessario confirmar todos os itens acima, clicando no checkbox.",  positionMy: "bottom left", positionAt: "top right" } : null)'

                    @onClickButton='cerNovPedidoAlterarPagina(1)'
                  ></RF-Button>
                </td>
              </tr>
            </table>
          </div>

          <div v-else-if="pagina === 1">
            <table style="width: 720px;">
              <tr>
                <td class="centro">
                  <RF-Icones
                    :cpntId='"cer-novo-pedido-icone-atencao"'
                    :cpntIcone='"alerta"'
                    :cpntIconeClass='"rf-icon-amarelo"'
                    :data-time='time'
                  ></RF-Icones>
                  <font style="margin-left: 10px; margin-right: 5px;" size="+1"><b>Importante:</b></font> Todas as informações abaixo preciam estar <b>atualizadas</b>. Após clique em Finalizar Pedido.
                  <hr style="margin: 10px 0px;"/>
                </td>
              </tr>
              <tr>
                <td>
                  <RF-Meu-Cadastro class="cer-novo-pedido-form"
                    :cpntFields="[ 'cnpj', 'razao', 'ie', 'email', 'telefone', 'cep', 'estado', 'cidade', 'endereco', 'numero', 'complemento', 'bairro', 'rep_leg', 'rep_cpf', 'rep_nas' ]" 
                    :cpntApiValid='apiValidMeuCadastro'
                    :cpntNomeButton='"Finalizar Pedido"'

                    :cpntFecharCadastro='cerNovPedidoFinalizaAtualizacao'
                  ></RF-Meu-Cadastro>
                </td>
              </tr>
            </table>
          </div>

          <div v-else-if="pagina === 2">
            <h3 class="centro" style="margin-bottom: 20px; margin-top: 0px;">
              <RF-Icones
                :cpntId='"cer-novo-pedido-icone-certo"'
                :cpntIcone='"check-circulo"'
                :cpntIconeClass='"rf-icon-verde"'
                :data-time='time'
              ></RF-Icones>

              Seu pedido foi realizado com sucesso.
            </h3>

            <table class="seu-pedido">
              <tr>
                <td>
                  <div class="quadrado">
                    <div class="titulo">
                      <i aria-hidden="true" class="fa fa-angle-double-right"></i>
                      INFORMAÇÕES GERAIS
                    </div>
                    <div class="conteudo" style="min-height: 220px; padding: 45px 15px 15px 15px;">
                      <table>
                        <tr v-if="pedido.hasOwnProperty('protocolo')">
                          <td style="width: 130px;">Protocolo:</td>
                          <td v-html="pedido.protocolo"></td>
                        </tr>
                        <tr v-if="pedido.hasOwnProperty('dt_pedido')">
                          <td style="width: 130px;">Pedido feito em:</td>
                          <td v-html="pedido.dt_pedido"></td>
                        </tr>
                        <tr v-if="pedido.hasOwnProperty('cnpj')">
                          <td style="width: 130px;">CNPJ:</td>
                          <td style="text-decoration: underline;" v-html="pedido.cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '\$1.\$2.\$3\/\$4\-\$5')"></td>
                        </tr>
                        <tr v-if="pedido.hasOwnProperty('modelo')">
                          <td style="width: 130px;">Modelo:</td>
                          <td v-html="pedido.modelo"></td>
                        </tr>
                        <tr v-if="pedido.hasOwnProperty('boleto_vcto')">
                          <td style="width: 130px;">Vencimento boleto:</td>
                          <td style="text-decoration: underline;" v-html="pedido.boleto_vcto"></td>
                        </tr>
                        <tr v-if="pedido.hasOwnProperty('boleto_url')">
                          <td style="width: 130px; padding: 0px 4px;">Boleto:</td>
                          <td style=" padding: 0px 4px;">
                            <a class="btn btn-primary btn-sm" :href="pedido.boleto_url" target="_blank" style="text-decoration: underline; text-shadow: none;">Gerar Boleto</a>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="quadrado">
                    <div class="titulo">
                      <i aria-hidden="true" class="fa fa-angle-double-right"></i>
                      DADOS DO AGENDAMENTO
                    </div>
                    <div class="conteudo" style="min-height: 220px; padding: 45px 15px 15px 15px;">
                      <table>
                        <template v-if="!pedido.hasOwnProperty('agendamento')">
                          <tr>
                            <td>
                              <div class="centro" style="font-weight: normal; padding-top: 8px;">
                                <RF-Icones
                                  :cpntId='"cer-novo-pedido-icone-agendamento"'
                                  :cpntIcone='"alerta"'
                                  :cpntIconeClass='"rf-icon-amarelo icone-agendamento"'
                                  :data-time='time'
                                ></RF-Icones>
                                <br/>
                                <br/>
                                Seu agendamento ainda não foi confirmado.
                                <br/>
                                <br/>
                                Por favor aguarde o contado da nossa equipe para agendamento, qualquer dúvida envie um e-mail para <a :href="'mailto:certificado@subase.com.br'" target="_blank">certificado@subase.com.br</a>.
                              </div>
                            </td>
                          </tr>
                        </template>
                        <template v-else-if="pedido.hasOwnProperty('agendamento')">
                          <tr v-if="pedido.agendamento.hasOwnProperty('data')">
                            <td style="width: 103px;">Data/Hora:</td>
                            <td style="text-decoration: underline;" v-html="pedido.agendamento.data"></td>
                          </tr>
                          <tr v-if="pedido.agendamento.hasOwnProperty('local')">
                            <td style="width: 103px;">Local:</td>
                            <td v-html="pedido.agendamento.local"></td>
                          </tr>
                          <tr v-if="pedido.agendamento.hasOwnProperty('rua')">
                            <td style="width: 103px;">Rua:</td>
                            <td>
                              <a :href="pedido.agendamento.link_end" target="_blank">
                                <span v-html="pedido.agendamento.rua"></span>
                                <span v-html="', ' + pedido.agendamento.numero"></span>
                              </a>
                            </td>
                          </tr>
                          <tr v-if="pedido.agendamento.hasOwnProperty('comp') && pedido.agendamento.comp !== ''">
                            <td style="width: 103px;">Complemento:</td>
                            <td v-html="pedido.agendamento.comp"></td>
                          </tr>
                          <tr v-if="pedido.agendamento.hasOwnProperty('bairro')">
                            <td style="width: 103px;">Bairro:</td>
                            <td v-html="pedido.agendamento.bairro"></td>
                          </tr>
                          <tr v-if="pedido.agendamento.hasOwnProperty('cidade')">
                            <td style="width: 103px;">Cidade/UF:</td>
                            <td>
                              <span v-html="pedido.agendamento.cidade"></span>
                              <span>/</span>
                              <span v-html="pedido.agendamento.uf"></span>
                            </td>
                          </tr>
                        </template>
                      </table>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="2" class="centro logos">
                  <table class="condicoes">
                    <tr>
                      <td class="checkbox-marcado">
                        <div class="quadrado">
                          <div class="titulo">
                            <RF-Checkbox-Tabela :data-time='time' style='cursor: pointer; position: relative; top: 0px;'
                              :cpntStatus='""'
                              :cpntId='"cer-novo-pedido--checkbox--pagamento"' 
                              :cpntNome='"EMISSÃO DO CERTIFICADO"'
                              :cpntValue='"pagamento"'
                              :cpntChecked='[ "pagamento" ]'
                              :cpntDisabled='true'

                              :cpntOnChange='cerNovoPedidoOnChangeCheckbox'
                            ></RF-Checkbox-Tabela>
                          </div>
                          <div class="conteudo">
                            • Após realizar este pedido, nossa equipe entrará em contato com você (no período da tarde) para fazer o agendamento.<br/><br/>
                            • Nossa agenda fica aberta para validação presencial nas Segundas, Quartas e Sextas no período da tarde.
                          </div>
                        </div>
                      </td>

                      <td class="checkbox-marcado">
                        <div class="quadrado">
                          <div class="titulo">
                            <RF-Checkbox-Tabela :data-time='time' style='cursor: pointer; position: relative; top: 0px;'
                              :cpntStatus='""'
                              :cpntId='"cer-novo-pedido--checkbox--emissao"' 
                              :cpntNome='"VALIDAÇÃO PRESENCIAL"'
                              :cpntValue='"emissao"'
                              :cpntChecked='[ "emissao" ]'
                              :cpntDisabled='true'

                              :cpntOnChange='cerNovoPedidoOnChangeCheckbox'
                            ></RF-Checkbox-Tabela>
                          </div>
                          <div class="conteudo">
                            • Após o agendamento, você será informado de todos os documentos necessários.<br/><br/>
                            • É necessário ser o Representante Legal da Empresa para gerar este certificado.<br/><br/>
                            • Nossa filial fica localizada na Rua Professor João Doetzer, 415 SLJ 02 no bairro Jardim das Américas em Curitiba/PR. (Com Estacionamento)
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="checkbox-marcado">
                        <div class="quadrado">
                          <div class="titulo">
                            <RF-Checkbox-Tabela :data-time='time' style='cursor: pointer; position: relative; top: 0px;'
                              :cpntStatus='""'
                              :cpntId='"cer-novo-pedido--checkbox--validacao"' 
                              :cpntNome='"FORMA DE PAGAMENTO"'
                              :cpntValue='"validacao"'
                              :cpntChecked='[ "validacao" ]'
                              :cpntDisabled='true'

                              :cpntOnChange='cerNovoPedidoOnChangeCheckbox'
                            ></RF-Checkbox-Tabela>
                          </div>
                          <div class="conteudo">
                            • Boleto Bancário<br/><br/>
                            • O vencimento será daqui a cinco dias.<br/><br/>
                            • O boleto deve ser pago até 2 (dois) dias antes da validação presencial.
                          </div>
                        </div>
                      </td>

                      <td class="checkbox-marcado">
                        <div class="quadrado">
                          <div class="titulo">
                            <RF-Checkbox-Tabela :data-time='time' style='cursor: pointer; position: relative; top: 0px;'
                              :cpntStatus='""'
                              :cpntId='"cer-novo-pedido--checkbox--atualizacao"' 
                              :cpntNome='"COMO INSERIR NO ROTINA FÁCIL"'
                              :cpntValue='"atualizacao"'
                              :cpntChecked='[ "atualizacao" ]'
                              :cpntDisabled='true'

                              :cpntOnChange='cerNovoPedidoOnChangeCheckbox'
                            ></RF-Checkbox-Tabela>
                          </div>
                          <div class="conteudo">
                            • Após a emissão do certificado conosco, será necessário gerar e inserir posteriormente o certificado no sistema.<br/><br/>
                            • Caso tenha dúvidas por favor entre em contato.
                          </div>
                        </div>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td colspan="2" class="centro logos">
                  <img src="./subase.png" style="height: 90px"/>

                  <img src='./safeweb.png' style="height: 60px"/>
                </td>
              </tr>
            </table>

            <!-- <br/>
            <br/>
            <br/>
            <div v-html="pedido"></div> -->
          </div>
        </div>
      </template>
    </RF-Dialog>
  </div>
</template>

<style scoped="">
  .esquerda {
    text-align: left;
  }
  .centro {
    text-align: center;
  }
  .direita {
    text-align: right;
  }
  .negrito {
    font-weight: bold;
  }
  .quadrado {
    width: 345px;
    min-width: 345px;
    max-width: 345px;
    margin: 0px auto;
  }
    .quadrado > .titulo {
      background-color: #264f6c;
      border: 1px solid #e6e5f5;
      border-top-right-radius: 5px;
      border-top-left-radius: 5px;
      border-bottom-right-radius: 15px;
      border-bottom-left-radius: 15px;
      padding: 10px 15px;
      color: #fff;
      text-shadow: none;
      width: 100%;
      float: right;
      text-align: left;
    }
    .quadrado > .conteudo {
      background: #e9e9e9;
      border: 1px solid #ccc;
      border-radius: 15px;
      padding: 60px 15px 15px 15px;
      min-height: 240px;
      text-align: justify
    }
      .quadrado > .conteudo > .item {
        margin: 10px 0px;
      }
      .quadrado > .conteudo > .item:first-child {
        margin-top: 0px;
      }
.cer-novo-pedido {
  padding-top: 10px;
}
  .modelo {
    width: 100%;
    margin-bottom: 20px
  }
    .modelo > tr > td {
      width: 50%;
      padding: 0px 10px;
    }
  .condicoes > tr > td {
    vertical-align: top;
    padding: 10px;
  }
  .condicoes > tr > .checkbox-desmarcado {
    opacity: 0.7;
  }

  .seu-pedido {
    width: 100%;
  }
    .seu-pedido > tr > td {
      padding: 0px 5px;
      vertical-align: top;
    }
      .seu-pedido > tr > td > .quadrado > .conteudo > table {
        width: 100%;
      }
        .seu-pedido > tr > td > .quadrado > .conteudo > table > tr > td {
          padding: 4px 4px;
        }
        .seu-pedido > tr > td > .quadrado > .conteudo > table > tr > td:first-child {
          text-align: right;
          font-weight: 600;
        }
        .seu-pedido > tr > td > .quadrado > .conteudo > table > tr > td:last-child {
          text-align: left;
        }

        .seu-pedido > tr > .logos {
          padding-top: 10px;
        }
        .seu-pedido > tr > .logos > img {
          margin: 0px 10px;
        }
</style>

<style>
.cer-novo-pedido-form > div > div > div > .rf-form > .rf-separador-6 {
  display: block !important;
}
.quadrado > .titulo > .rf-web-checkbox > label > span {
  margin-left: 5px;
  cursor: pointer;
}
.seu-pedido > tr > td > .quadrado > .conteudo > table > tr > td div > span > .icone-agendamento {
  font-size: var(--font-base-soma-30);
}
.condicoes > tr > .checkbox-marcado > div > div > .rf-web-checkbox > input[type=checkbox]:disabled + label span {
  color: #fff !important;
}
</style>

<script>
  export default {
    components: {
      'RF-Meu-Cadastro': () => import('@/components/config/cadastro/Meu-Cadastro.vue'),
      'RF-Checkbox-Tabela': () => import('@/components/rf-geral/checkbox/RF-Checkbox-Tabela.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        tipos: [
          {
            img: '',
            nome: 'e-CNPJ | A1 - Arquivo',
            valor: 17500,
            validade: '12 MESES'
          }
        ],
        checkbox: [],
        certificadoValue: [ 0 ],
        pagina: null,
        pedido: {},
        apiValidMeuCadastro: {}
      }
    },
    mounted: function () {
      this.cerNovPedidoIniciar()
    },
    methods: {
      cerNovPedidoIniciar: function () {
        var self = this

        // LIMPA OS DADOS DO PEDIDO
        self.pedido = {}

        // SETA A NOVA DATA PARA FORÇAR A ATUALIZAÇÃO DOS COMPONENTS
        this.time = new Date().getTime()

        // CHAMA FUNÇÃO PARA ACEITAR O CONTRATO
        self.$store.state.comunicaAPI('/config/cadastro/get', 'GET', null, function (apiSuccess) {
          if (self.$store.state.FUN_VALIDA_INFORMACAO(apiSuccess.data.cda1_pedido) === -1) {
            // CARREGA OS DADOS DO PEDIDO SELECIONADO
            self.pedido = JSON.parse(apiSuccess.data.cda1_pedido)

            // SETA A NOVA DATA PARA FORÇAR A ATUALIZAÇÃO DOS COMPONENTS
            self.time = new Date().getTime()
          }

          if (self.pedido.hasOwnProperty('protocolo')) {
            // SETA O MODELO DE CERTIFICADO QUE ESTA SENDO GERADO
            self.pedido.modelo = "E-CNPJ A1"

            // SETA OS DADOS DO AGENDAMENTO
            if (self.pedido.hasOwnProperty('agenda_dia') && self.pedido.hasOwnProperty('agenda_hora')) {
              self.pedido.agendamento = {
                data: self.pedido.agenda_dia + ' às ' + self.pedido.agenda_hora,
                local: 'SUBASE JD DAS AMÉRICAS',
                rua: 'Rua Professor João Doetzer',
                numero: '415',
                comp: 'Sobreloja 02',
                bairro: 'Jardim das Américas',
                cidade: 'Curitiba',
                uf: 'PR',
                link_end: 'https://www.google.com/maps/dir//R.+Prof.+Jo%C3%A3o+Doetzer,+415+-+Jardim+das+Am%C3%A9ricas,+Curitiba+-+PR,+81540-190/@-25.4623943,-49.2251122,17z/data=!4m17!1m7!3m6!1s0x94dce547f391e07b:0x360944e26f7c473d!2sR.+Prof.+Jo%C3%A3o+Doetzer,+415+-+Jardim+das+Am%C3%A9ricas,+Curitiba+-+PR,+81540-190!3b1!8m2!3d-25.4623943!4d-49.2229235!4m8!1m0!1m5!1m1!1s0x94dce547f391e07b:0x360944e26f7c473d!2m2!1d-49.2229235!2d-25.4623943!3e3'
              }
            }
          }

          // SETA O NUMERO DA PAGINA QUE SERÁ MOSTRADO
          Object.keys(self.pedido).length >= 1 ? self.cerNovPedidoAlterarPagina(2) : self.cerNovPedidoAlterarPagina(0)
        }, self.cerNovPedidoSetaStatusGeral)
      },
      cerNovPedidoSetaStatusGeral: function (status) {
        // SETA O NUMERO DA PAGINA
        this.pagina = status

        // SETA A NOVA DATA PARA FORÇAR A ATUALIZAÇÃO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      cerNovPedidoAlterarPagina: function (id) {
        // SETA O NUMERO DA PAGINA
        this.pagina = id

        // SETA A NOVA DATA PARA FORÇAR A ATUALIZAÇÃO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      
      cerNovPedidoFinalizaAtualizacao: function (acao) {
        switch (acao) {
          case 'enviar':
            this.cerNovoFinalizarPedido()
            break
        
          default:
            this.statusGeral = { loc: 'WEB', cod: '500', err: 'Erro ao identificar callback atualização do cadastro.' }
            break
        }
      },
      cerNovoPedidoOnChangeCheckbox: function (value, id) {
        // PEGA O NOME DO CHECKBOX RECEBIDO
        var index = id.split('--')

        // VERIFICA SE DEVE OU NÃO MARCAR O CHECKBOX
        switch (value) {
          case true:
            this.checkbox.push(index[2])
            break

          case false:
            this.checkbox = this.checkbox.filter(item => item !== index[2])
            break
        }

        // REMOVER VALORES DUPLICADOS
        this.checkbox = this.checkbox.filter((v, i, a) => a.indexOf(v) === i)
                
        // SETA A NOVA DATA PARA FORÇAR A ATUALIZAÇÃO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      cerNovoFinalizarPedido: function () {
        var self = this

        // CHAMA FUNÇÃO PARA ACEITAR O CONTRATO
        self.$store.state.comunicaAPI('/subase/safeweb/pedido', 'POST', null, function (apiSuccess) {
          self.$store.state.TRATAR_RET_LOT_API(apiSuccess, self.cerNovPedidoIniciar)
        }, self.cerNovPedidoSetaStatusGeral, function (apiValid, apiStatus) {
          switch (apiStatus) {
            case 409:
              self.$store.state.msgWarn('API [' + apiStatus + ']: ' + apiValid.geralWeb, 'danger')
              break

            default:
              self.apiValidMeuCadastro = apiValid
              break
          }
        })
      },
      cerNovPedidoFechar: function () {
        this.$router.push({ name: 'pag_inicial' })
      },
      cerNovPedidoFormatarValor: function (valor) {
        return this.$store.state.FUN_MASK_VALOR('valorMoeda', valor)
      },
    },
    computed: {
      cerNovPedidoCalcularTotal: function () {
        // INICIA O VALOR TOTAL SELECIONADO
        var valor = 0

        // CALCULA O VALOR TOTAL SELECIONADO
        for (var key in this.certificadoValue) {
          valor += this.tipos[this.certificadoValue[key]].valor
        }

        // RETORNA O VALOR CALCULADO
        return this.cerNovPedidoFormatarValor(valor)
      }
    }
  }
</script>
